
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t, i18n } = useTranslation('common');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ja' ? 'en' : 'ja';
    i18n.changeLanguage(newLang);
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/20 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/24aeac95850e55fcda9f6af40f64c6a6/5533c6b9721b42fabcee3c27bfcaba87.png"
              alt="Yamauchi Partners"
              className="h-10 w-auto object-contain"
            />
          </Link>

          <div className="flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.home')}
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.services')}
            </button>
            <button
              onClick={() => scrollToSection('travel')}
              className="text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.travel')}
            </button>
            <button
              onClick={() => scrollToSection('school')}
              className="text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.school')}
            </button>
            <button
              onClick={() => scrollToSection('company')}
              className="text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.company')}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-sm font-medium hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.contact')}
            </button>

            <button
              onClick={toggleLanguage}
              className="px-4 py-2 text-sm font-medium bg-gray-900 text-white rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              {i18n.language === 'ja' ? 'EN' : 'JA'}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
